import InfiniteScroll from 'infinite-scroll';

export default function initArchive( selector = '.inf-scroll', options = {} )
{
	const element = document.querySelector(selector);
    if (!element) return;

	if( !document.querySelector('.load-more-tiles') ) return;
	
	const defaultOptions = {
        path: '.load-more-tiles',
		button: '.load-more-tiles',
        append: '.tile',
		scrollThreshold: false,
        history: false
    };

	let infScroll = new InfiniteScroll(selector, { ...defaultOptions, ...options });
}